module.exports = __webpack_public_path__ + "assets/tagline_web_desktop_it.svg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/taglines/tagline_web_desktop_it.svg
// module id = 444
// module chunks = 19